import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CaretUpOutlined, CaretDownOutlined, TeamOutlined } from '@ant-design/icons';
import Table from 'components/Table/index';
import { Space, Button } from 'antd';
import { fetchGetAtendentesLista, fetchGetAtendenteById } from 'store/fetchActions/fetchAtendente';
import { duckAtendenteDetalhar } from 'store/ducks/atendente';
import { convertDatePtBrHs } from 'utils/dateFormatter';
import { widthLabel } from 'utils/stringFormatter';
import { cpfMaskView } from 'utils/masks';
import * as S from './styles';

export default function GridAtendente({ filtro }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const dadosGrid = useSelector(state => state.atendente?.todosAtendentes?.list);
  const paginacao = useSelector(state => state.atendente?.todosAtendentes);

  const [ordenacao, setOrdenacao] = useState({});

  const montarLinha = lista => {
    return lista?.map(item => {
      return {
        key: item?.id,
        nome: widthLabel(item?.nome),
        email: widthLabel(item?.email),
        dataCadastro: convertDatePtBrHs(item?.dataCadastro),
        cargo: item?.cargo?.descricao,
        situacao: item?.situacao?.descricao,
        documento: cpfMaskView(item?.documento),
        isSetorial: item?.isSetorial,
      };
    });
  };

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetAtendentesLista(1, 10));
    dispatch(duckAtendenteDetalhar(null));
  }, [dispatch, unitaryTests]);

  const renderAction = row => {
    return (
      <Space>
        <Button onClick={() => dispatch(fetchGetAtendenteById(row?.key, history))}>Detalhar</Button>
      </Space>
    );
  };

  const changePage = (page = 1, pageSize = 10) => {
    dispatch(fetchGetAtendentesLista(page, pageSize, filtro));
  };

  const sorterColum = (coluna, sentidoOrdenacao) => {
    setOrdenacao({ coluna, sentidoOrdenacao });
    const filtroOrdenacao = {
      ...filtro,
      SentidoOrdenacao: sentidoOrdenacao,
      CampoOrdenacao: coluna,
    };
    dispatch(fetchGetAtendentesLista(paginacao?.numberPage || 1, paginacao?.sizePage || 10, filtroOrdenacao));
  };

  const getIcon = name => {
    if (ordenacao?.sentidoOrdenacao === 'Desc' && name === ordenacao?.coluna) {
      return <CaretDownOutlined onClick={() => sorterColum(name, 'Asc')} />;
    } else if (ordenacao?.sentidoOrdenacao === 'Asc' && name === ordenacao?.coluna) {
      return <CaretUpOutlined onClick={() => sorterColum(name, 'Desc')} />;
    } else {
      return <CaretUpOutlined onClick={() => sorterColum(name, 'Asc')} />;
    }
  };

  const renderTitulo = (texto, name) => {
    return (
      <S.ContainerOrdenacao className="ant-table-cell">
        {texto}
        <S.IconOrdenacao>{getIcon(name)}</S.IconOrdenacao>
      </S.ContainerOrdenacao>
    );
  };

  const columns = [
    {
      title: () => renderTitulo('Nome', 'Nome'),
      dataIndex: 'nome',
      key: 'nome',
    },
    {
      title: () => renderTitulo('Documento', 'Documento'),
      dataIndex: 'documento',
      key: 'documento',
    },
    {
      title: () => renderTitulo('E-mail', 'Email'),
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: () => renderTitulo('Data de Cadastro', 'DataCadastro'),
      key: 'dataCadastro',
      dataIndex: 'dataCadastro',
    },
    {
      title: () => renderTitulo('Cargo', 'Cargo.Descricao'),
      dataIndex: 'cargo',
      key: 'cargo',
      render: (cargoExibir, row) => (
        <>
          {row?.isSetorial && (
            <>
              {cargoExibir} <TeamOutlined />
            </>
          )}
          {!row?.isSetorial && cargoExibir}
        </>
      ),
    },
    {
      title: () => renderTitulo('Situação', 'Situacao.Descricao'),
      dataIndex: 'situacao',
      key: 'situacao',
    },
    {
      title: '-',
      key: 'action',
      align: 'center',
      render: record => renderAction(record),
    },
  ];

  return <Table columns={columns} data={montarLinha(dadosGrid)} paginationConfig={paginacao} changePage={changePage} />;
}
